<template>
  <div class="text-left">
    <BreadcrumbsNav />
    <v-row align="center">
      <v-col cols="12" sm="10" class="pb-12">
        <h1 class="text-h4 font-weight-black mb-8">Espace Nutritioniste</h1>
        <p>
          Bienvenue dans l'espace dédié aux nutritionistes ! Retrouvez ici toutes les ressources, conseils et outils
          pour accompagner les convives, analyser les menus et améliorer la qualité nutritionnelle des repas.
        </p>
      </v-col>
      <v-col cols="2">
        <v-img
          src="/static/images/doodles-dsfr/primary/SittingChef.png"
          v-if="$vuetify.breakpoint.smAndUp"
          class="mx-auto rounded-0"
          contain
          max-width="100%"
        ></v-img>
      </v-col>
    </v-row>
    <!-- Section 1: IA Prédictive de Rechute Alimentaire -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6">
        <v-img
          src="/static/images/prediction-trouble.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
      <v-col cols="12" md="6">
        <h2 class="text-h5 font-weight-bold mb-4">IA Prédictive de Rechute Alimentaire</h2>
        <p>
          Grâce à la synchronisation en temps réel avec des outils connectés, bracelets d'activité ou applis sportives
          pour croiser données nutritionnelles et activité physique, pour ajuster les recommandations en continu, nous
          proposons:
        </p>
        <ul>
          <li>Algorithme d'analyse des signaux faibles de décrochage</li>
          <li>Alertes préventives basées sur les changements de comportement</li>
          <li>Suggestions d'interventions personnalisées avant la rechute</li>
        </ul>
      </v-col>
    </v-row>

    <!-- Section 2: Module Famille/Entourage Connecté -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6" order-md="1" order="2">
        <h2 class="text-h5 font-weight-bold mb-4">Module Famille/Entourage Connecté</h2>
        <p>
          Avec un espace sécurisé pour le partage de dossiers et la coordination entre diététiciens, médecins,
          psychologues et autres professionnels de santé, favorisant une approche globale du suivi ou de la prévention,
          nous proposons:
        </p>
        <ul>
          <li>Interface dédiée pour impliquer la famille dans le suivi</li>
          <li>Partage sécurisé des recommandations avec les proches</li>
          <li>Coaching familial pour harmoniser l'environnement alimentaire à domicile</li>
        </ul>
      </v-col>
      <v-col cols="12" md="6" order-md="2" order="1">
        <v-img
          src="/static/images/doodles-dsfr/primary/Hi.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
    </v-row>

    <!-- Section 3: Gamification Thérapeutique Avancée -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6">
        <v-img
          src="/static/images/dashboard-dieteticien.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
      <v-col cols="12" md="6">
        <h2 class="text-h5 font-weight-bold mb-4">Gamification Thérapeutique Avancée</h2>
        <p>
          Peu d'outils permettent de mesurer si les plans alimentaires ou conseils sont réellement suivis dans les
          cantines ou à domicile. Peu d'outils sont interopérables avec les logiciels de gestion de menus, de production
          ou de traçabilité utilisés en restauration collective. Avec Labricot vous pourrez suivre les comportements
          alimentaires dans un cadre collectif et mettre en place vos solutions en utilisant:
        </p>
        <ul>
          <li>Système de défis progressifs adaptatifs selon les objectifs</li>
          <li>Récompenses virtuelles et réelles intégrées</li>
          <li>Communauté de patients avec challenges collectifs anonymisés</li>
        </ul>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BreadcrumbsNav from "@/components/BreadcrumbsNav"

export default {
  name: "NutritionistePage",
  components: { BreadcrumbsNav },
}
</script>
<style scoped>
.gestionnaire-img {
  max-height: 400px;
  width: auto;
}
@media (max-width: 600px) {
  .gestionnaire-img {
    max-width: 320px;
    height: auto;
    max-height: none;
  }
}
</style>
